
export default {
  name: 'Downloads',
  props: {
    downloads: {
      type: Array,
      default: () => [],
    },
    theme: {
      type: String,
      default: 'primary',
      validator(value) {
        return ['primary', 'dark'].includes(value)
      },
    },
  },
  computed: {
    formattedDownloads() {
      return this.downloads.filter(
        (downloadItem) => downloadItem?.title.length > 0,
      )
    },
  },
}
